import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Images/logo.svg'


const _hoisted_1 = { class: "flex backdrop-filter backdrop-blur-sm bg-opacity-30 z-50 fixed top-0 justify-between items-center md:w-10/12 mx-auto text-white md:py-3 py-2 w-11/12 border-b-[1px] border-gray-800" }
const _hoisted_2 = { class: "antialiased w-full" }
const _hoisted_3 = { class: "flex items-center justify-between sx:flex-col bg-teal" }
const _hoisted_4 = { class: "sx:w-full flex mx:items-center sx:justify-between" }
const _hoisted_5 = { class: "no-underline flex justify-center items-center sm:mt-0 text-teal-lighter hover:text-white md:mr-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-6",
  src: _imports_0,
  alt: "you-read logo"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("form", { class: "md:w-[400px] w-8/12 mx-2 px-2 py-2 text-sm flex justify-center rounded-[6px] bg-gray-400 backdrop-filter backdrop-blur-sm bg-opacity-30" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 1024 1024",
    class: "w-5 mr-1",
    xmlns: "http://www.w3.org/2000/svg",
    "data-v-ea893728": ""
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("input", {
    placeholder: "Search Books",
    class: "outline-none bg-transparent w-full h-full"
  })
], -1)
const _hoisted_8 = { class: "block md:hidden" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current h-3 w-3",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "Menu"),
  /*#__PURE__*/_createElementVNode("path", { d: "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"text-sm sm:flex-grow flex sx:flex-col sx:items-start sx:justify-start\"><div class=\"no-underline mt-4 flex justify-center items-center md:mt-0 text-teal-lighter hover:text-white mr-4\"> For Authors </div><div class=\"no-underline flex justify-center items-center mt-4 md:mt-0 text-teal-lighter hover:text-white mr-4\"> For Readers </div><div class=\"no-underline flex justify-center items-center mt-4 md:mt-0 text-teal-lighter hover:text-white mr-4\"> Company <svg viewBox=\"0 0 1024 1024\" class=\"w-5 ml-1\" xmlns=\"http://www.w3.org/2000/svg\" data-v-ea893728=\"\"><path fill=\"currentColor\" d=\"M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z\"></path></svg></div></div>", 1)
const _hoisted_12 = { class: "flex justify-center sx:mt-4 gap-6 items-center m-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Login = _resolveComponent("Login")
  const _component_Signup = _resolveComponent("Signup")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              class: "text-sm sx:hidden",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createTextVNode("You-Read")
              ]),
              _: 1
            })
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "flex items-center px-2 py-2 border rounded text-teal-lighter border-teal-light hover:text-white hover:border-white",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggle && $options.toggle(...args)))
            }, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([$data.open ? 'block': 'hidden', "w-full flex-grow md:flex md:items-center md:w-auto"])
        }, [
          _hoisted_11,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Login),
              _createVNode(_component_Signup)
            ])
          ])
        ], 2)
      ])
    ])
  ]))
}